import React from "react";

export default function Footer() {
  return (
    <div className="container mx-auto justify-center items-center text-center mt-[10px] mb-[20px]">
      copyright : Asrari ZIkran 2023
    </div>
  );
}
